module.exports = __webpack_public_path__ + "static/media/agile.cc28cd64.jpeg";